






































import { getModule } from "vuex-module-decorators";
import { Component, Vue, Prop } from "vue-property-decorator";
import CongestionGraphConfig from "./data/CongestionGraphConfig";
import * as qlog from '@/data/QlogSchema';

import ConnectionConfigurator from "@/components/shared/ConnectionConfigurator.vue";
import ConnectionStore from "@/store/ConnectionStore";
import ConnectionGroup from "@/data/ConnectionGroup";
import Connection from "@/data/Connection";

@Component({
    components: {
        ConnectionConfigurator,
    },
})
export default class CongestionGraphConfigurator extends Vue {
    @Prop()
    public config!: CongestionGraphConfig;

    public store:ConnectionStore = getModule(ConnectionStore, this.$store);

    public onConnectionSelected(connection:Connection) {
        console.log("CongestionGraphConfigurator:onConnectionSelected : ", this.config, connection);

        this.config.connection = connection;
    }

    public resetZoom(){
        // TODO hook up properly
        this.config.renderer.resetZoom();
    }

    public useBrushX(){
        // TODO hook up properly
        this.config.renderer.useBrushX();
    }

    public useBrush2d(){
        // TODO hook up properly
        this.config.renderer.useBrush2d();
    }

    public useRuler(evt:any = undefined) {
        if ( evt ){
            // console.error( " KEYUP ", evt );
            if ( evt.code !== "KeyR" ){
                return;
            }
        }

        console.log("CongestionGraphConfigurator: Using ruler");

        this.config.renderer.useRuler();
    }

    public toggleCongestionGraph(){
        // TODO hook up properly
        this.config.renderer.toggleCongestionGraph();
    }

    public toggleRTTZoom() {
        this.config.renderer.toggleZoomingRTTGraph();
    }

    public togglePerspective(){
        // TODO hook up properly
        this.config.renderer.togglePerspective();
    }

    protected get isClientSideTrace(){
        return  this.config && 
                this.config.connection && 
                this.config.connection.vantagePoint && 
                (this.config.connection.vantagePoint.type === qlog.VantagePointType.client || this.config.connection.vantagePoint.flow === qlog.VantagePointType.client);
    }

    public mounted(){
        if ( this.config.connection === undefined && this.store.groups.length > 0 ){
            this.selectDefault();
        }

        document.addEventListener('keyup', this.useRuler);
    }

    public beforeDestroy() {
        document.removeEventListener("keyup", this.useRuler);
    }

    public updated(){
        if ( this.config.connection === undefined && this.store.groups.length > 0 ){
            this.selectDefault();
        }
    }

    protected selectDefault(){
        console.log("selectDefault: adding new default connection configurator", this.store.groups);
        this.config.connection = ( this.store.groups[0].getConnections()[0] );
    }
}

